











































































import { defineComponent } from '@vue/composition-api';
import TipBox from '@/components/common/tip-box/index.vue';
import ALink from '@/components/common/a-link/a-link.vue';

const name = 'ttam-location-tips';
export default defineComponent({
  name,
  components: { TipBox, ALink },
  props: {
    japanVideoTipsVisible: {
      type: Boolean,
      default: false,
    },
    dsaTipsVisible: {
      type: Boolean,
      default: false,
    },
    offlineAreaTipsVisible: {
      type: Boolean,
      default: false,
    },
    offlineAreaTips: {
      type: String,
      default: '',
    },
    isDSALoading: {
      type: Boolean,
      default: false,
    },
    isCLA: {
      type: Boolean,
      default: false,
    },
    isZipcodeTips: {
      type: Boolean,
      default: false,
    },
    brandSafetyTipVisible: {
      type: Boolean,
      default: false,
    },
    brandSafetyTipContent: {
      type: String,
      default: '',
    },
    anchorTipContent: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const openDSAClick = () => {
      emit('open-DSAClick');
    };
    return {
      name,
      openDSAClick,
    };
  },
});
